import { i18n } from 'boot/i18n';

export function cms(key: any, default_value: string | null = null) {
  const t = i18n.global.t;

  // The config of i18n in the boot file will
  // cause translations with missing keys to return ''.
  return t(key)?.length ? t(key) : (default_value ?? '');
}
